import fetchRequest from "src/network";
import { authActionLogout, authActionSessionUpdate } from "src/redux/reducers/auth.reducer";
import { store } from "src/redux/store";
// import { swalError } from "./sweetPopup";
import { BookingStatus, NameTitle, UserGender } from "./localData";
import routes from "src/routes";
import moment from "moment";
import { swalError } from "./sweetPopup";
import AppColors from "./appColors";
import { MdArrowRightAlt } from "react-icons/md";
import { setCustomerShuttleAllowedState } from "src/redux/reducers/roleManagement.reducer";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const mobileRegex = /^[6-9]\d{9}$/;

const isNotNull = (val) => (val !== null && val !== undefined && val !== '');

const isNotZero = (num) => (num !== 0 && num !== "");

const isNotStringZero = (num) => (num !== "0" && num !== 0 && num !== "");

const errorMsg = {
  tokenExpireMsg: {
    message: "Error!",
    error_message: "User session expired or invalid user token"
  },
  forbiddenError: {
    message: "Error!",
    error_message: "Access Forbidden: Not Authorized"
  }
};

const isTokenExpire = (res, endPoint) => {
  if (res?.status_code === 401) {
    console.log("res_lo", res);
    console.log("endpoint_lo", endPoint);
    if (!endPoint?.includes("/auth/logout")) {
      // swalError(res);
    }
    return true;
  } else if (res?.status_code === 403) {
    if (!endPoint?.includes("/auth/logout")) {
      swalError(errorMsg?.forbiddenError);
    }
    return false;
  } else {
    return false;
  }
};

const logOutUser = () => {
  store.dispatch(authActionLogout());
  store.dispatch(setCustomerShuttleAllowedState(false));
  fetchRequest.get('/auth/logout')
    .then((response) => {
      console.log("RESPONSE", response);
    }).catch((error) => {
      console.log("ERROR", error);
    });
};

// Reload the user, so a changed role or scopes show without a new login.
const checkSession = () => {
  fetchRequest.get('/auth/session')
    .then((response) => {
      if (response?.status_code === 200 && isNotNull(store?.getState()?.authReducer?.data)) {
        store.dispatch(authActionSessionUpdate(response?.data?.user));
      }
    }).catch((error) => {
      console.log("ERROR", error);
    });
}

const isFormData = (data) => {
  return data instanceof FormData;
}

const getTitleKey = (title) => {
  if (title === "") return "";
  return NameTitle?.filter((i) => i?.value === title ? i?.key : "")?.[0]?.key ?? "";
}

const getGenderKey = (gender) => UserGender?.filter((i) => i?.value === gender ? i?.key : "")?.[0]?.key ?? "";

const openInNewTab = (url) => {
  window.open(url, "_self");
}

const removeBracketId = (input) => {
  return input.replace(/\s*\(\d+\)/, '');  // \(\d+\) matches the number in parentheses
}

const getBookingStatusString = (status) => {
  return BookingStatus?.filter(i => i?.value === status)?.[0]?.key;
}

const removeLastTwoZeros = (str) => {
  return str.replace(/:\d{2}$/, "");
}

const flotToTime = (flot) => {
  if (isNotNull(flot) && !isNaN(flot)) {
    const hours = Math.floor(flot);
    const minutes = Math.round((flot - hours) * 60); // Get the decimal part, convert to minutes
    // if (hours === 0 && minutes === 0) {
    //   return "0m";
    // } else if (hours === 0) {
    //   return `${minutes}m`;
    // } else if (minutes === 0) {
    //   return `${hours}h`;
    // }
    return `${hours}h ${minutes}m`;
  }
  return "-";
}

const formatExactTime = (val) => {
  // Return "-" immediately if val is null, undefined, or empty
  if (val === null || val === undefined || val === '') {
    return "-";
  }
  // Allow 0.00 as a valid input for 0h 0m
  if (val < 0 || val > 24.00) {
    return "Invalid time. Please pass a valid decimal time between 0.00 and 24.00.";
  }

  const hours = Math.floor(val);
  const minutes = Math.round((val % 1) * 100);

  // Direct check for 0h 0m condition
  if (hours === 0 && minutes === 0) {
    return "0:0";
  }

  function getFutureTime(hours, minutes = 0) {
    const now = new Date();

    now.setHours(now.getHours() + hours);
    now.setMinutes(now.getMinutes() + minutes);

    return now.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  }

  return getFutureTime(hours, minutes);
};

const parseTimeToHoursMinutes = (timeStr) => {
  if (timeStr === null || timeStr === undefined || timeStr === "" || timeStr === "-") {
    return null;
  }

  let hours = 0;
  let minutes = 0;
  const strVal = timeStr.toString().trim();

  // 1. Check if it is a colon-separated time format (e.g., "04:30" or "04:30:00")
  if (strVal.includes(':')) {
    const parts = strVal.split(':');
    const parsedHours = parseInt(parts[0], 10);
    const parsedMinutes = parseInt(parts[1], 10);
    if (!isNaN(parsedHours) && !isNaN(parsedMinutes)) {
      return { hours: parsedHours, minutes: parsedMinutes };
    }
  }

  // 2. Check if it is a formatted time string like "4h 30m", "4h", or "30m"
  if (strVal.includes('h') || strVal.includes('m')) {
    const match = strVal.match(/^(?:(\d+)h)?\s*(?:(\d+)m)?$/);
    if (match) {
      hours = match[1] ? parseInt(match[1], 10) : 0;
      minutes = match[2] ? parseInt(match[2], 10) : 0;
      return { hours, minutes };
    }
  }

  // 3. Otherwise, treat it as a decimal/float representation of hours (e.g., 4.5 or "4.5" or "4")
  const num = parseFloat(strVal);
  if (!isNaN(num)) {
    hours = Math.floor(num);
    minutes = Math.round((num - hours) * 60);
    return { hours, minutes };
  }

  return null;
};

const formatToClockWithPeriod = (timeStr) => {
  if (timeStr === null || timeStr === undefined || timeStr === "" || timeStr === "-") return "-";

  const parsed = parseTimeToHoursMinutes(timeStr);
  if (!parsed) return "Invalid Format";

  const { hours, minutes } = parsed;

  // Handle your 0h 0m rule
  if (hours === 0 && minutes === 0) {
    return "0:0";
  }

  // Determine AM or PM based on the hours value
  // 12:00 to 23:59 is PM, 00:00 to 11:59 is AM
  const period = hours >= 12 ? "PM" : "AM";

  // Convert hours to 12-hour format (e.g., 15 becomes 3)
  const displayHours = hours % 12 || 12;
  const paddedMinutes = minutes.toString().padStart(2, '0');

  return `${displayHours}:${paddedMinutes} ${period}`;
};

const formatToHoursMinutes = (timeStr) => {
  console.log("timeStr", timeStr);
  if (timeStr === null || timeStr === undefined || timeStr === "" || timeStr === "-") return "-";

  const parsed = parseTimeToHoursMinutes(timeStr);
  if (!parsed) return "Invalid Format";

  const { hours, minutes } = parsed;

  // If both hours and minutes are 0, return "0:0" as requested before
  if (hours === 0 && minutes === 0) {
    return "0:0";
  }

  // Pad the minutes to ensure it always has 2 digits (e.g., "0" becomes "00")
  const paddedMinutes = minutes.toString().padStart(2, '0');

  return `${hours}:${paddedMinutes}`;
};

const getLocState = (loc) => {
  let locState = store?.getState()?.locStateReducer?.data ?? [];
  let result = locState?.filter((i) => i?.id === loc && i)?.[0]?.name;
  if (isNotNull(result)) {
    return result;
  }
  return loc?.toString()?.toUpperCase();
}

const getRouteRow = (pathName) => {
  return routes?.filter((i) => i?.path === pathName)?.[0]
}

function numberToWords(num) {
  if (num === 0) return 'zero';

  const belowTwenty = [
    'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten',
    'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'
  ];
  const tens = [
    '', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'
  ];
  const thousands = ['', 'thousand', 'million', 'billion'];

  function convertHundred(num) {
    let result = '';
    if (num >= 100) {
      result += belowTwenty[Math.floor(num / 100)] + ' hundred ';
      num %= 100;
    }
    if (num >= 20) {
      result += tens[Math.floor(num / 10)] + ' ';
      num %= 10;
    }
    if (num > 0) {
      result += belowTwenty[num] + ' ';
    }
    return result.trim();
  }

  function convertToWords(num) {
    let result = '';
    let thousandCounter = 0;

    while (num > 0) {
      if (num % 1000 !== 0) {
        result = convertHundred(num % 1000) + ' ' + thousands[thousandCounter] + ' ' + result;
      }
      num = Math.floor(num / 1000);
      thousandCounter++;
    }

    return result.trim();
  }

  return convertToWords(num);
}


function convertFloatToWords(num) {
  if (isNaN(num) || num === null) return "Invalid Amount";

  // Use fixed precision to handle floating point errors (e.g., 0.1 + 0.2)
  const parts = parseFloat(num).toFixed(2).split('.');
  const integerPart = parseInt(parts[0]);
  const decimalPart = parseInt(parts[1]);

  const integerWords = numberToWordsWithPaisa(integerPart);

  if (decimalPart > 0) {
    const decimalWords = numberToWordsWithPaisa(decimalPart);
    return `${integerWords} Rupees and ${decimalWords} Paisa Only`.toUpperCase();
  } else {
    return `${integerWords} Rupees Only`.toUpperCase();
  }
}

function numberToWordsWithPaisa(num) {
  if (num === 0) return 'Zero';

  const belowTwenty = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
    'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
  ];
  const tens = [
    '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
  ];

  // Helper to handle chunks
  function getWords(n) {
    let str = "";
    if (n >= 100) {
      str += belowTwenty[Math.floor(n / 100)] + " Hundred ";
      n %= 100;
    }
    if (n >= 20) {
      str += tens[Math.floor(n / 10)] + " ";
      n %= 10;
    }
    if (n > 0) {
      str += belowTwenty[n] + " ";
    }
    return str;
  }

  let result = "";

  // Crores
  if (Math.floor(num / 10000000) > 0) {
    result += getWords(Math.floor(num / 10000000)) + "Crore ";
    num %= 10000000;
  }
  // Lakhs
  if (Math.floor(num / 100000) > 0) {
    result += getWords(Math.floor(num / 100000)) + "Lakh ";
    num %= 100000;
  }
  // Thousands
  if (Math.floor(num / 1000) > 0) {
    result += getWords(Math.floor(num / 1000)) + "Thousand ";
    num %= 1000;
  }
  // Hundreds/Remaining
  result += getWords(num);

  return result.trim();
}


function convertDateFormat(dateString) {
  if (isNotNull(dateString)) {
    return moment(dateString, 'YYYY-MM-DD').format('DD/MM/YYYY');
  } else {
    return "-";
  }
}

function convertDateTimeFormat(dateString) {
  if (isNotNull(dateString)) {
    return moment(dateString, 'YYYY-MM-DD HH:mm')?.format('DD/MM/YYYY HH:mm');
  } else {
    return "-";
  }
}

const toLocalDate = (dateString) => {
  if (isNotNull(dateString)) {
    return moment(dateString)?.format("ll HH:mm");
  }
  return "";
}

const toFormattedDate = (dateString) => {
  if (isNotNull(dateString)) {
    return moment(dateString)?.format("YYYY-MM-DD")
  }
  return "";
}

const formattedCurrentDate = () => {
  return moment()?.format('YYYY-MM-DD');
}

const toSlashFormattedDate = (dateString) => {
  if (isNotNull(dateString)) {
    return moment(dateString)?.format('DD/MM/YY');
  }
  return "";
}

const toFormattedDateRangeView = (startDate, endDate) => {
  if (isNotNull(startDate) && isNotNull(endDate)) {
    return <div className="d-flex justify-content-between align-items-center"><div>{moment(startDate)?.format("DD-MM-YYYY")}</div>
      {<MdArrowRightAlt size={20} />}
      <div>{moment(endDate)?.format("DD-MM-YYYY")}</div></div>;
  }
  return "";
};

const toFormattedSingleDate = (dateString) => {
  if (isNotNull(dateString)) {
    return moment(dateString)?.format("DD-MM-YYYY");
  }
  return "";
}

const toFormattedDateTimeView = (dateString) => {
  if (isNotNull(dateString)) {
    return moment(dateString)?.format("DD-MM-YYYY HH:mm");
  }
  return "";
}

const toFormattedSingleTime = (dateString) => {
  if (isNotNull(dateString)) {
    return moment(dateString, 'HH:mm')?.format("HH:mm");
  }
  return "";
}

const getUser = (obj) => obj?.user;

const getValueByKey = (arr, value) => arr?.filter((i) => i?.value === value ? i?.key : "")?.[0]?.key ?? "";

const getDateTimeDiff = (bookingEndDate, bookingEndTime, bookingStartDate, bookingStartTime) => {
  const endDate = moment(`${bookingEndDate} ${bookingEndTime}`, 'YYYY-MM-DD HH:mm');
  const startDate = moment(`${bookingStartDate} ${bookingStartTime}`, 'YYYY-MM-DD HH:mm');

  const totalMinutes = endDate.diff(startDate, 'minutes');

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${isNaN(hours) ? 0 : hours} hours and ${isNaN(minutes) ? 0 : minutes} minutes`;
}

const getDateTimeDiffInNumber = (bookingEndDate, bookingEndTime, bookingStartDate, bookingStartTime) => {
  const endDate = moment(`${bookingEndDate} ${bookingEndTime}`, 'YYYY-MM-DD HH:mm');
  const startDate = moment(`${bookingStartDate} ${bookingStartTime}`, 'YYYY-MM-DD HH:mm');

  const totalMinutes = endDate.diff(startDate, 'minutes');

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  // format as HH:mm (with leading zero if needed)
  const formatted = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;

  return isNaN(totalMinutes) ? "00:00" : formatted;
};

const getTaxableOrNonTaxable = (data) => {
  let taxable = [];
  let nonTaxable = [];

  if (isNotNull(data)) {
    const keyNames = {
      state_tax_gst: { value: "State Tax", field: "state_tax_charges" },
      mcd_charges_gst: { value: "MCD Charges", field: "mcd_charges" },
      toll_charges_gst: { value: "Toll Charges", field: "toll_charges" },
      fastag_charges_gst: { value: "Fastag Charges", field: "fastag_charges" },
      parking_charges_gst: { value: "Parking Charges", field: "parking_charges" }
    };

    // Iterate through the object
    for (const [key, value] of Object.entries(data)) {
      // Skip keys containing "amount"
      if (key.includes("amount")) {
        continue;
      }

      const readableName = keyNames[key] || key; // Fallback to key if no mapping exists
      if (value) {
        taxable.push({ key: readableName, value });
      } else {
        nonTaxable.push({ key: readableName, value });
      }
    }
  }
  return {
    taxable: taxable,
    nonTaxable: nonTaxable,
  }
}

const ratingColor = (rating) => {
  switch (rating) {
    case 1:
      return AppColors?.red;
    case 2:
      return AppColors?.orange;
    case 3:
      return AppColors?.yellow;
    case 4:
      return AppColors?.lightGreen;
    case 5:
      return AppColors?.green;
    default:
      return "transparent";
  }
}

const bookingPriorityColor = (priority) => {
  switch (priority) {
    case 'FEMALE':
      return AppColors?.lightPink;
    case 'VVIP':
      return AppColors?.greenYellow;
    case 'VIP':
      return AppColors?.lightGreenYellow;
    case 'LUGGAGE_CAR':
      return AppColors?.lightYellow;
    case 'CARRIER_CAR':
      return AppColors?.lightBlue;
    default:
      return '';
  }
}

const columnStyle = (item) => {
  if (item?.is_first_booking) {
    return { backgroundColor: "#fcb1a5" }
  }
  return { backgroundColor: bookingPriorityColor(item?.booking_priority) }
}

const removeHash = (value) => {
  if (typeof (value) === "string") {
    if (value?.startsWith("#")) {
      return value?.slice(1);
    } else {
      return value;
    }
  } else {
    return value;
  }
}

const removeHifand = (value) => value?.split("_")?.join(" ");

function getFinYrList() {
  const list = ["---Select financial year---"];

  let current = new Date().getFullYear();
  for (let i = 2024; i <= current; i++) {
    let startYr = i;
    let endYr = i + 1;

    list.push(`${startYr}-${endYr}`)
  }
  return list;
}

const setDateByString = (value, isFirst = true) => {
  if (value === "current_month") {
    return isFirst ? moment().startOf("month").format("YYYY-MM-DD") : moment().endOf("month").format("YYYY-MM-DD")
  } else {
    return moment().format("YYYY-MM-DD");
  }
}

const statusShortMsg = (status) => {
  switch (status) {
    case "PENDING":
      return "Awaiting confirmation";
    case "CONFIRMED":
      return "Ready to dispatch";
    case "DISPATCHED":
      return "On the way";
    case "CLOSED":
      return "Completed";
    case "DUTY_ENDED":
      return "Service completed";
    case "CANCELLED":
      return "Booking cancelled";
    default:
      return "";
  }
}

const screenMode = (type = 0) => {
  switch (type) {
    case 1:
      return "view";
    case 2:
      return "edit";
    default:
      return "create";
  }
}

const formatToTwoDecimals = (value) => {
  const num = Number(value);
  if (isNaN(num) || !Number.isFinite(num)) {
    return new Error(`Invalid number: ${value}`);
  }
  return num?.toFixed(2);
}

const isInternalUser = (user = null) => {
  if (user === null) {
    user = store?.getState()?.authReducer?.data?.user;
  }
  return user?.is_staff ?? false;
}

// Helper function to clean CSV field values
const cleanCSVField = (value) => {
  if (!value) return "";
  let cleaned = String(value)
    .replace(/\t/g, " ")  // Replace tabs with spaces
    .replace(/\n/g, " ")  // Replace newlines with spaces
    .replace(/\r/g, "")   // Remove carriage returns
    .replace(/"/g, '""')  // Escape quotes by doubling them
    .trim();
  return cleaned;
};

const numUptoTwoDecimal = (num) => {
  num = Number(num);
  if (!Number.isFinite(num)) {
    num = 0;
  }
  return Number(num?.toFixed(2));
}

const numUptoTwoDecimalStr = (num) => {
  num = Number(num);
  if (!Number.isFinite(num)) {
    num = 0;
  }
  return num?.toFixed(2);
}

const RefObject = {
  CUSTOMER: 'customer',
  VENDOR: 'vendor',
  DRIVER: 'driver',
  USER: 'user',
  BOOKING: 'booking',
  VEHICLE: 'vehicle',
};

const UploadTypes = {
  VENDOR_TNC: "VENDOR_TNC",
  VENDOR_BANK: "VENDOR_BANK",
  KYC: "KYC",
  RECEIPT: "RECEIPT",
  VEHICLE_DOCS: "VEHICLE_DOCS",
};

export {
  RefObject,
  UploadTypes,
  emailRegex,
  isNotNull,
  isNotZero,
  isNotStringZero,
  logOutUser,
  errorMsg,
  isTokenExpire,
  checkSession,
  isFormData,
  getTitleKey,
  getGenderKey,
  openInNewTab,
  removeBracketId,
  getBookingStatusString,
  flotToTime,
  formatExactTime,
  formatToClockWithPeriod,
  formatToHoursMinutes,
  getLocState,
  getRouteRow,
  numberToWords,
  numberToWordsWithPaisa,
  getUser,
  getValueByKey,
  getDateTimeDiff,
  getDateTimeDiffInNumber,
  convertFloatToWords,
  convertDateFormat,
  convertDateTimeFormat,
  toLocalDate,
  toFormattedDate,
  formattedCurrentDate,
  toSlashFormattedDate,
  getTaxableOrNonTaxable,
  ratingColor,
  removeLastTwoZeros,
  bookingPriorityColor,
  columnStyle,
  removeHash,
  removeHifand,
  getFinYrList,
  setDateByString,
  statusShortMsg,
  screenMode,
  mobileRegex,
  toFormattedDateRangeView,
  toFormattedSingleDate,
  toFormattedDateTimeView,
  toFormattedSingleTime,
  formatToTwoDecimals,
  isInternalUser,
  cleanCSVField,
  numUptoTwoDecimal,
  numUptoTwoDecimalStr
};